(function() {
    let products_info = get_the_right_product();
    change_collection_price(products_info);

    /********************************************************************/


    function get_the_right_product() {
        let products = {
            'activity': get_the_right_activity_products(),
            'daily_deal': get_the_right_daily_products(),
            'weekly_deal': get_the_right_weekly_products()
        };

        let the_right_product = {};
        for (let i in products['activity']) {
            let id = products.activity[i].id;
            the_right_product[id] = products.activity[i]; 
        }

        if (products.weekly_deal && !(products.weekly_deal.id in the_right_product)) {
            let id = products.weekly_deal.id;
            the_right_product[id] = products.weekly_deal; 
        }
        
        if (products.daily_deal && !(products.daily_deal.id in the_right_product)) {
            let id = products.daily_deal.id;
            the_right_product[id] = products.daily_deal; 
        }

        return the_right_product;
    }

    function change_collection_price(products_info) {
        let n = 0;
        let change_collection_price_timer = setInterval(function() {
            if (++n >= 300) {
                clearInterval(change_collection_price_timer);
                change_collection_price_timer = null;
                return ;
            }
        
            let obj_list = $('.hdt-card-product__wrapper');
            if (obj_list.length <= 0) {
                return ;
            }

            obj_list.each(function() {
                let pid = $.trim($(this).find(".product_id_hidden").text());
                if (!pid || !(pid in products_info)) {
                    return ;
                }
                
                let html = "<del><span changed='1' class='money'>$" + products_info[pid].compare_price + "</span></del>&nbsp;&nbsp;";
                html += "<span class='money' changed='1' style='color:#ec0101'>$" + products_info[pid].real_price + "</span></ins>";
                $(this).find('.hdt-price-wrapp').empty().append(html);
            });
        }, 50);
    }

    function get_the_right_daily_products() {
        if (!daily_deal_products?.show) {
            return null;
        }
  
        const now = set_now_time();
        const { list, start_time } = daily_deal_products;
        for (let i in list) {
            const start_time_str = `${this_year}-${i} ${start_time}`;
            const start_timestamp = convert_datetime_to_timestamp(start_time_str);
            const end_timestamp = start_timestamp + 12 * 3600;
            if (now < end_timestamp && now > start_timestamp) {
                return {
                    'id': product_common_info[list[i].product].id,
                    'compare_price': list[i].variant_price[0][0].toFixed(2),
                    'real_price': list[i].variant_price[0][1].toFixed(2)
                }
            }
        }
  
        return null;
    }

    function get_the_right_weekly_products() {
        if (!weekly_deal_products?.show) {
            return null;
        }

        const now = set_now_time();
        const { list, start_time } = weekly_deal_products;
        for (let i in list) {
            const start_time_str = `${this_year}-${i} ${start_time}`;
            const start_timestamp = convert_datetime_to_timestamp(start_time_str);
            const end_timestamp = start_timestamp + 7 * 24 * 3600;
            if (now < end_timestamp && now > start_timestamp) {
                return {
                    'id': product_common_info[list[i].product].id,
                    'compare_price': list[i].variant_price[0][0].toFixed(2),
                    'real_price': list[i].variant_price[0][1].toFixed(2)
                }
            }
        }
  
        return null;
    }

    function get_the_right_activity_products() {
        const now = set_now_time();
        const { show, start_time, end_time } = activity_products;
        if (!show) {
            return null;
        }
        if (start_time && now < convert_datetime_to_timestamp(start_time)) {
            return null;
        }
        if (end_time && now > convert_datetime_to_timestamp(end_time)) {
            return null;
        }

        let products = {};
        for (let i in activity_products.list) {
            let item = activity_products.list[i];
            let id = product_common_info[i].id;
            products[id] = {
                'id': id,
                'compare_price': item.variant_price[0][0].toFixed(2),
                'real_price': item.variant_price[0][1].toFixed(2),
            }
        }

        return products;
    }
})();

